import React from 'react';
import {PlayerScenario} from "../features/player_scenario/components/PlayerScenario/PlayerScenario";


const PlayerScenarioPage = () => {




    return (
        <div style={{maxWidth:"500px", height:"100%", margin:"0 auto"}}>
            <PlayerScenario/>
         </div>
    );
};

export  {PlayerScenarioPage};